'use client'
import { createContext, type ReactNode, useMemo } from 'react'
import { AdSizePredictions } from '@/services/api/guj/dtos/AdSizePrediction.dto'

export enum PageType {
  Overview,
  Article,
}

export interface AppContextState {
  adSizePrediction?: AdSizePredictions
  adDebugMode?: boolean
  pageMetaData: PageMetaDataProps
  pushedAdSlots: Array<string>
}

interface PageMetaDataProps {
  adZone: string
  noAds: boolean
  noVideoAds?: boolean
  overrideAdZone?: string
  keywords?: Array<string>
}

export const initialAppContext = {
  adSizePrediction: undefined,
  adDebugMode: process.env.NEXT_PUBLIC_ENABLE_AD_DEBUG_MODE == 'true',
  pageMetaData: {
    adZone: '_default',
    keywords: [],
    noAds: false,
    noVideoAds: false,
  },
  pushedAdSlots: [],
}

interface AppProviderProps {
  children: ReactNode
  value: Partial<AppContextState>
}

export const AppContext = createContext<AppContextState>(initialAppContext)

export const AppProvider = ({ children, value }: AppProviderProps) => {
  const state = useMemo(
    () => ({
      ...initialAppContext,
      ...value,
    }),
    [value],
  )

  return <AppContext.Provider value={state}>{children}</AppContext.Provider>
}
